import { MutationTree } from "vuex";
import { AuthState } from ".";
import { User } from "../../models/auth.model";

export const AuthMutationTypes = {
  SetUser: "SET_USER",
  SetToken: "SET_TOKEN"
};

export const mutations: MutationTree<AuthState> = {
  [AuthMutationTypes.SetUser](state: AuthState, payload: User) {
    state.user = payload;
  },
  [AuthMutationTypes.SetToken](state: AuthState, payload: string) {
    state.token = payload;
  }
};
